import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["span", "br", "strong", "em", "a"];
const ALLOWED_ATTR = ["class", "style", "href"];

const LINK_REGEX =
  /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]|www\.[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
const BOLD_REGEX =
  /(?<=(?:^|\s|\b))\*(?!\*{2,})(?!_\*+)(\*?_\S[^*]*?\S_*\*|\S(?:[^*]*?\S)?(?:_\S[^*]*?\S)*)\*(?=(?:\s|$|_|<em>|<\/em>|\S))/g;
const ITALIC_REGEX =
  /(?<=(?:^|\s|\b))_(?!_{2,})(?!\*)(?<!_+_\*+)(\*?_\S[^_]*?\S_*\*|\S(?:[^_]*?\S)?(?:\*\S[^_]*?\S)*)_(?=(?:\s|$|\*|<strong>|<\/strong>|\S))/g;

const processLine = (line) => {
  if (!line) return "";

  let result = line;

  result = result.replace(LINK_REGEX, (match) => {
    const url = match.startsWith("www.") ? `https://${match}` : match;
    return `<a href="${url}" style="color: #027eb5; text-decoration: underline;">${match}</a>`;
  });

  result = result.replace(BOLD_REGEX, (_, p1) => {
    return `<strong>${p1}</strong>`;
  });

  result = result.replace(ITALIC_REGEX, (_, p1) => {
    return `<em>${p1}</em>`;
  });

  return result;
};

export function formatParagraph(text) {
  if (!text) return [];

  const lines = text.split("\n");

  return lines.map((line, index) => {
    const processedLine = processLine(line);

    if (!processedLine) {
      return <br key={`line-${index}`} />;
    }

    const sanitizedHtml = DOMPurify.sanitize(processedLine, {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
    });

    return (
      <div
        key={`line-${index}`}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  });
}
